module.exports = __webpack_public_path__ + "assets/images/botao.bacf1785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/botao.png
// module id = 684
// module chunks = 1